export default __webpack_public_path__ + "static/media/add-resource-enabled.0c2d01f4.svg";